import { useTranslation } from 'react-i18next';
import React, { FC } from 'react';
import { CrossedPrice } from 'common/components/product-price-view';
import { ServiceCard, ServiceCardButton, ServiceCardContent } from '../service-card';
import {
  linkRow,
  buttonText,
  originalPrice,
  priceContainer,
  verticalContainer,
  flags,
  container,
  button,
} from './styles';
import { Discount } from './components';
import { RelatedServiceProps } from '../types';
import { cx } from 'linaria';
import { FlagsIcon } from './components/flags-icon';

export const DATA_QA_DISCOUNT_RELATED_SERVICE = 'discount-related-services';

export const DiscountRelatedService: FC<RelatedServiceProps> = ({
  service: { title, price, sales },
  href,
  onClick,
  vertical,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <ServiceCard
      onClick={onClick}
      href={href}
      className={cx(linkRow, className)}
      containerClassName={!vertical ? container : undefined}
      vertical={vertical}
      dataQA={DATA_QA_DISCOUNT_RELATED_SERVICE}
    >
      {vertical && <FlagsIcon className={flags} />}
      <ServiceCardContent title={title}>
        <div className={cx(priceContainer, vertical ? verticalContainer : null)}>
          <Discount value={sales?.discountPercent || 0} />
          <CrossedPrice
            price={`${sales?.originalPrice}`}
            currency={t('ui.currency')}
            mini
            className={originalPrice}
          />
        </div>
      </ServiceCardContent>
      <ServiceCardButton
        className={!vertical ? button : undefined}
        price={price?.value}
        textClassName={buttonText}
        priceClassName={buttonText}
      />
    </ServiceCard>
  );
};
